import { queryOptions } from '@tanstack/react-query';
import { http } from '../common/http-client';

export type ComplianceItem = {
  sensitive_content: string;
  risk_level: 'low' | 'medium' | 'high';
  reason: string;
  suggestion: string;
};

export type ComplianceResult = {
  rewritten_content: string;
  sensitive_words: ComplianceItem[];
};

export const getCheckComplianceOptions = (prompt: string) =>
  queryOptions({
    queryKey: ['合规说明', 'json', prompt],
    queryFn: ({ signal }) =>
      http
        .post('script/prompt/moderate', { json: { prompt }, signal })
        .json<ComplianceResult>(),
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    retry: false,
  });
